import React from "react";
import { Breadcrumbs as MUIBreadcrumbs, Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

const Breadcrumbs = ({ city, category, item }) => {
  return (
    <MUIBreadcrumbs sx={{ mb: 2, textTransform: "capitalize" }}>
      <Link component={RouterLink} to="/">
        Home
      </Link>

      <Link component={RouterLink} to={`/city/${city}`}>
        {city}
      </Link>

      <Link component={RouterLink} to={`/city/${city}/${category}`}>
        {category}
      </Link>

      <Typography color="text.primary">{item}</Typography>
    </MUIBreadcrumbs>
  );
};

export default Breadcrumbs;
